// A production's picture (its logo or poster, set in its settings), or its initials on a neutral square.
import type { Project } from "../types.ts";
import { useAssetUrl } from "../useAsset.ts";
import { useApp } from "./app.ts";

/** The production's picture, or its initials on a neutral square when it has none. */
export function ProjectPicture({ project, size }: { project: Project; size: number }) {
  const { api, ws } = useApp();
  const { url } = useAssetUrl(api, ws, project.image_asset_version_id ?? null);
  const src = url?.thumbnail_url ?? url?.url ?? null;
  return (
    <span className="k-projpic" style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}>
      {src ? (
        <img src={src} alt="" decoding="async" />
      ) : (
        <span aria-hidden="true">{monogram(project.name)}</span>
      )}
    </span>
  );
}

const monogram = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("") || "·";
